import { useCallback, useContext, useEffect } from "react";
import AuthContext, { AuthContextType } from "./context.";
import PrivateUser from "../dtos/user";
import UserService from "../service/user";
import { getAuthToken, LOCAL_STORAGE_AUTH_TOKEN_KEY } from "./storage";
import { ApiError } from "../api";

function useAuthContext(): AuthContextType {
  const context = useContext(AuthContext);

  if (context === undefined)
    throw new Error(
      "Eroare interna. AuthContext nu ar trebui sa fie niciodata undefined."
    );

  return context;
}

export default function useAuth(): PrivateUser | null {
  const context = useAuthContext();

  const refresh = useRefreshAuth();
  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, []);

  return context[0];
}

export function useIsAuth(): () => boolean {
  const callback = useCallback(() => {
    return getAuthToken() !== null;
  }, []);
  return callback;
}

export function useRefreshAuth() {
  const context = useAuthContext();
  const callback = useCallback(async () => {
    const value = localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN_KEY);
    if (value === null) {
      context[1](null);
    } else {
      const service = new UserService();
      service.read
        .current()
        .then(context[1])
        .catch((error) => {
          // if (error instanceof ApiError && error.status === 401) logout();
          localStorage.removeItem(LOCAL_STORAGE_AUTH_TOKEN_KEY);
          context[1](null);
        });
    }
    // eslint-disable-next-line
  }, []);
  return callback;
}

export function useLogin() {
  const refresh = useRefreshAuth();

  return async (
    public_id_or_email: string,
    password: string,
    recaptchaToken: string
  ) => {
    return await new UserService().create
      .login(recaptchaToken, public_id_or_email, password)
      .then(async (value) => {
        localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN_KEY, value);
        await refresh();
      });
  };
}

export function useLogout(): () => Promise<void> {
  const refresh = useRefreshAuth();
  const callback = useCallback(async () => {
    try {
      await new UserService().delete.logout();
    } catch (error) {
      if (!(error instanceof ApiError && error.status === 401)) throw error;
    }
    localStorage.removeItem(LOCAL_STORAGE_AUTH_TOKEN_KEY);
    refresh();
    // eslint-disable-next-line
  }, []);
  return callback;
}
